import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import TabsPageLayout from '../../../components/TabsPageLayout';
import useDevice from '../../../queries/deviceDetails/useDevice';
import { useDeviceTabsDataCounts } from 'src/hooks/device';
import { PORTAL_ROUTE } from 'src/constants/routes';
import { deviceTabs, DEVICES_PREVIOUS_PATH } from './constant';

const AppDetails = () => {
  const { deviceId } = useParams();
  const { data: device } = useDevice({ deviceId });

  const { data: counts, isLoading, isFetching } = useDeviceTabsDataCounts({ deviceId });

  const backNavigationPath = useMemo(() => {
    const storedPath = sessionStorage.getItem(DEVICES_PREVIOUS_PATH);
    return storedPath || `${PORTAL_ROUTE}/devices`;
  }, []);

  return (
    <TabsPageLayout
      hasBackButton
      backNavigationPath={backNavigationPath}
      title={device?.device?.name}
      tabs={deviceTabs(deviceId, counts, isLoading || isFetching)}
      wrapperProps={{
        sx: {
          maxWidth: '100%',
        },
      }}
      titleProps={{
        fontSize: '1.4rem',
      }}
    />
  );
};

export default AppDetails;
